export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ASSETS = {
  heroBg: 'https://static.prod-images.emergentagent.com/jobs/29a6bf31-1090-456a-928c-cef9b74782c6/images/af22be6e49dbb2cc9e7677fcee2c6cd487db1f5475438378acda63f38e63df8a.png',
  scrollDark: 'https://customer-assets.emergentagent.com/job_29a6bf31-1090-456a-928c-cef9b74782c6/artifacts/a7agg9km_IMG_2064.jpeg',
  scrollBlank: 'https://customer-assets.emergentagent.com/job_29a6bf31-1090-456a-928c-cef9b74782c6/artifacts/oc2y5hqc_IMG_2064.jpeg',
  scrollFrame: 'https://customer-assets.emergentagent.com/job_29a6bf31-1090-456a-928c-cef9b74782c6/artifacts/fekdtz26_IMG_2064.jpeg',
  seekerImg: 'https://customer-assets.emergentagent.com/job_29a6bf31-1090-456a-928c-cef9b74782c6/artifacts/j1cxkvdv_IMG_2069.png',
};
